import React, { Component, cloneElement } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  selectAccount,
  selectAccountRole,
  fetchAccountActions,
} from '../../account-management/ducks';
import { AccountProfileContainer } from '../../account-management/containers';

const mapStateToProps = (state, props) => ({
  account: selectAccount(state),
  accountRole: selectAccountRole(state),
  accountId: props.params.accountId,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchAccount: fetchAccountActions.request,
    },
    dispatch
  ),
});

@connect(mapStateToProps, mapDispatchToProps)
export default class CallCentrumContainer extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    account: PropTypes.object,
    accountRole: PropTypes.string,
    accountId: PropTypes.string.isRequired,
  };

  componentDidMount() {
    const { actions, accountId } = this.props;
    actions.fetchAccount({ accountId });
  }

  componentDidUpdate(prevProps) {
    const { actions, accountId } = this.props;
    if (prevProps.accountId !== accountId) {
      actions.fetchAccount({ accountId });
    }
  }

  render() {
    const { account, accountId } = this.props;

    return cloneElement(<AccountProfileContainer />, { account, accountId });
  }
}



// WEBPACK FOOTER //
// ./src/features/call-centrum/containers/CallCentrumContainer.js